/**
 * Where a sound take's HIT is (2026-09-30): the first 10 ms window whose level reaches half the take's
 * loudest window — the clap of a cast, after any leading silence or quiet wind-up swell. A spell's SFX
 * is placed so this hit lands on its release clock (docs/FT3D_CAST_SYNC_AUDIT.md). The decoded buffer is
 * kept: the encounter schedules it through Web Audio against that clock.
 */
import { decodeAudioTakeInfo } from '../shared/audio-take';
export { takeHitSeconds, takeImpactSeconds } from '../shared/audio-take';

export interface EffectTake { buffer: AudioBuffer; hit: number; impact: number }
/** Pre-roll an <audio> fallback can afford: the release clock is only SPELL_RELEASE_MS ahead of the gesture. */
export const MAX_EFFECT_PREROLL_SECONDS = 0.7;

export function effectTake(url: string): Promise<EffectTake> {
    return decodeAudioTakeInfo(url);
}

export function effectHitSeconds(url: string): Promise<number> {
    return effectTake(url).then(take => take.hit);
}
